import { ComponentType } from "react";

/** Components a `component` field can render, addressed by name so page config stays serialisable. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fieldComponents: Record<string, ComponentType<any>> = {};

const warnedKeys = new Set<string>();

/** Filled from each record definition's own components, by recordDefinitions. */
export function registerFieldComponents(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  components: Record<string, ComponentType<any>> | undefined
) {
  Object.assign(fieldComponents, components);
}

/** Undefined for an unknown name, so an older build still renders the page. */
export function getFieldComponent(name: string | undefined) {
  const component = name ? fieldComponents[name] : undefined;

  if (
    name &&
    !component &&
    process.env.NODE_ENV === "development" &&
    !warnedKeys.has(name)
  ) {
    warnedKeys.add(name);
    console.warn(
      `No field component is registered as "${name}". Add it to a record definition's fieldComponents.`
    );
  }

  return component;
}
